/**
 * EventTypeService
 * Service for managing event types
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for event type CRUD operations
 */
export class EventTypeService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? EventTypeService.DEFAULT_SERVICE_PATH,
            basePath: EventTypeService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
EventTypeService.DEFAULT_SERVICE_PATH = 'events';
EventTypeService.BASE_PATH = 'api/event-types';
//# sourceMappingURL=EventTypeService.js.map